import classNames from 'classnames';
import React, {useState} from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import preferences from 'Preferences';
import {Header1, Title} from 'ui-library/Headers';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as nyc from 'ui-library/NYC';

interface FeatureBannerProps {
  children: JSX.Element;
  className?: string;
  seenBannerPreference?: string;
}

function FeatureBanner(props: FeatureBannerProps): JSX.Element | null {
  const [visible, setVisible] = useState(
    Boolean(props.seenBannerPreference == null || !preferences.get(props.seenBannerPreference))
  );

  function handleDismiss(): void {
    if (props.seenBannerPreference) {
      preferences.set(props.seenBannerPreference, true);
    }
    setVisible(false);
  }

  if (!visible) {
    return null;
  }

  return (
    <nyc.Row>
      <div className={classNames('featureBanner', props.className)}>
        {props.children}
        {props.seenBannerPreference && (
          <BenchlingIcon
            aria-label="Close"
            className="featureBanner-remove"
            {...getActionButtonRoleProps({onPress: handleDismiss})}
            icon="close"
          />
        )}
      </div>
    </nyc.Row>
  );
}

interface FeatureBannerItemProps {
  imageSource?: string;
  oversized: boolean;
  stepNumber?: number;
  subtitle: string;
  title: string;
}

export function FeatureBannerItem({
  imageSource,
  stepNumber,
  title,
  subtitle,
  oversized,
}: FeatureBannerItemProps): JSX.Element {
  return (
    <div className={classNames('featureBanner-item', {'featureBanner-title': oversized})}>
      {imageSource && (
        <img
          src={imageSource}
          className={classNames('featureBanner-icon', {'featureBanner-icon--large': oversized})}
        />
      )}
      {stepNumber && (
        <div className="featureBanner-stepNumber featureBanner-stepNumber--large">{stepNumber}</div>
      )}
      <div>
        {oversized ? <Header1>{title}</Header1> : <Title>{title}</Title>}
        <div className="featureBanner-subtitle">{subtitle}</div>
      </div>
    </div>
  );
}

export default FeatureBanner;
